<script setup lang="ts">
import { Head } from '@inertiajs/vue3';
import CookieConsentBanner from '@/components/CookieConsentBanner.vue';
</script>

<template>
    <Head>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="anonymous" />
        <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Geist:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap" />
    </Head>

    <slot />
    <CookieConsentBanner />
</template>
